/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    CommentOutlined,
    BadgeOutlined,
    CategoryOutlined,
    MenuBookOutlined,
    PersonAddAlt1Outlined,
    AgricultureOutlined,
    FlagOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Varietales from "./Secciones/Seccion_Varietales";
import Seccion_Categorias from "./Secciones/Seccion_Categorias";
import Seccion_Mayoristas from "./Secciones/Seccion_Mayoristas";
import Seccion_Solicitudes from "./Secciones/Seccion_Solicitudes";
import Seccion_Region from "./Secciones/Seccion_Region";
import Seccion_Origenes from "./Secciones/Seccion_Origenes";
import Seccion_Testimonios from "./Secciones/Seccion_Testimonios";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Solicitudes',
        icono: PersonAddAlt1Outlined,
        camino: '/Solicitudes',
        categoria: 'Solicitudes',
        Componente: <Seccion_Solicitudes/>
    },
    {
        nombre: 'Varietales',
        icono: MenuBookOutlined,
        camino: '/Varietales',
        categoria: 'Pagina',
        Componente: <Seccion_Varietales/>
    },
    {
        nombre: 'Testimonios',
        icono: CommentOutlined,
        camino: '/Testimonios',
        categoria: 'Pagina',
        Componente: <Seccion_Testimonios/>
    },
    {
        nombre: 'Categorias',
        icono: CategoryOutlined,
        camino: '/Categorias',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias/>
    },
    {
        nombre: 'Regiones',
        icono: AgricultureOutlined,
        camino: '/Regiones',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Region/>
    },
    {
        nombre: 'Origen',
        icono: FlagOutlined,
        camino: '/Origen',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Origenes/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}